<section class="text-muted py-5 background-color-main">
    <footer class="text-light pt-5 pb-3 background-color-main">
        <div class="container">
            <div class="row">
                <div class="col-6 col-md-2 mb-3">
                    <h5>Company</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="about" class="text-light me-3">About</a></li>
                        <li class="nav-item mb-2"><a href="careers" class="text-light me-3">Careers</a></li>
                        <li class="nav-item mb-2"><a href="partners" class="text-light me-3">Partners</a></li>
                        <li class="nav-item mb-2"><a href="support" class="text-light me-3">Support</a></li>
                        <li class="nav-item mb-2"><a href="events" class="text-light me-3">Events</a></li>
                        <li class="nav-item mb-2"><a href="photo-gallery" class="text-light me-3">Photo Gallery</a></li>
                        <li class="nav-item mb-2"><a href="impressum" class="text-light me-3">Impressum</a></li>
                        <li class="nav-item mb-2"><a href="privacy-policy" class="text-light me-3">Privacy</a></li>
                    </ul>
                </div>

                <div class="col-6 col-md-2 mb-3">
                    <h5>Blogs</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="blog" class="text-light me-3">Blogs</a></li>
                        <li class="nav-item mb-2"><a href="documentation" class="text-light me-3">Documentation</a></li>
                        <li class="nav-item mb-2"><a href="tools" class="text-light me-3">Free Tools</a></li>
                        <li class="nav-item mb-2"><a href="faqs" class="text-light me-3">FAQs</a></li>
                        <li class="nav-item mb-2"><a href="case-studies" class="text-light me-3">Case Studies</a></li>
                    </ul>
                </div>

                <div class="col-6 col-md-2 mb-3">
                    <h5>News</h5>
                    <ul class="nav flex-column">
                        <li class="nav-item mb-2"><a href="news" class="text-light me-3">Press Releases</a></li>
                        <li class="nav-item mb-2"><a href="social" class="text-light me-3">Social</a></li>
                    </ul>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12" style="height:50px;"></div>
            </div>

            <div class="row">
                <!-- Company Address -->
                <div class="col-md-4 mb-4">
                    <h5 class="mb-3">NordNative OÜ Address</h5>
                    <address>
                        {{CONTACT_US_ADDRESS_MAIN}}<br>
                        Phone: {{CONTACT_US_PHONE_MAIN}}<br>
                        Email: <a href="mailto:{{CONTACT_US_EMAIL_MAIN}}"
                            class="text-light">{{CONTACT_US_EMAIL_MAIN}}</a>
                    </address>
                    <small class="d-block mt-2 text-light">
                        NordNative OÜ is a registered entity in the Estonian Business Register.
                        <a href="https://ariregister.rik.ee/eng/company/16542275/NordNative-O%C3%9C" class="text-light"
                            target="_blank">View Registration</a>
                    </small>
                </div>

                <!-- Social Links -->

                <div class="col-md-4 mb-4 text-center">
                    <h5 class="mb-3">Follow Us</h5>
                    <div>
                        <a href="{{SOCIAL_LINK_FACEBOOK}}" target="_blank" class="text-light me-3">
                            <i class="fab fa-facebook fa-2x"></i>
                        </a>
                        <!-- <a href="{{SOCIAL_LINK_TWITTER}}" target="_blank" class="text-light me-3"><i
                  class="fab fa-twitter fa-2x"></i></a> -->
                        <a href="{{SOCIAL_LINK_INSTAGRAM}}" target="_blank" class="text-light me-3">
                            <i class="fab fa-instagram fa-2x"></i>
                        </a>
                        <a href="{{SOCIAL_LINK_LINKEDIN}}" target="_blank" class="text-light me-3">
                            <i class="fab fa-linkedin fa-2x"></i>
                        </a>
                        <a href="{{SOCIAL_LINK_YOUTUBE}}" target="_blank" class="text-light me-3">
                            <i class="fab fa-youtube fa-2x"></i>
                        </a>
                        <a href="{{SOCIAL_LINK_TIKTOK}}" target="_blank" class="text-light">
                            <i class="fab fa-tiktok fa-2x"></i>
                        </a>
                    </div>
                </div>

                <!-- Newsletter Subscription -->
                <div class="col-md-4 mb-4">
                    <app-newsletter-subs-form></app-newsletter-subs-form>
                </div>
            </div>

            <!-- Footer Bottom -->
            <div class="text-center mt-4">
                <small>&copy; {{ currentYear }} NordNative OÜ. All rights reserved.</small>
            </div>
        </div>
    </footer>
</section>
